import React, {useState} from 'react';
import {Container, Row, Col} from 'reactstrap';

import '../debtPayment.scss';
import BasicText from './basicText';
import BasicImage from './basicImage';
import PopUpComponent from './popUpComponent';
import Action from './action';
import Config from '../../../../Config';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import ChevronArrow from './chevronArrow';
import {isMobile} from 'react-device-detect';

/** LTR isolate around ₪ + amount so negatives render as ₪-20 (not 20-₪) in RTL Hebrew. */
const rtlShekelAmount = (amount) => '\u2066\u200E₪' + amount + '\u2069';

const ConsumerSelect = (props) => {
  const [isShowExtra, setShowExtra] = useState(false);
  const privateArrow = props.privateAmount ? '-private' : '';
  const arrow = require(`../images/icons-arrow${privateArrow}.svg`);
  const info = require('../images/icons-info.svg');
  const dial = require('../images/icons-call-phone.svg');
  const displayNumber = props.privateAmount ? props.idNumber : props.number;
  const actionOnClick = (e) => {
    gaEvent(
      gaParams.PRIVATEDEBT_ACCOUNTSHOW_CALL_CLICK.category,
      gaParams.PRIVATEDEBT_ACCOUNTSHOW_CALL_CLICK.eventType,
      gaParams.PRIVATEDEBT_ACCOUNTSHOW_CALL_CLICK.eventParams,
    );
    window.open('tel:' + e);
  };

  const renderPrivateDebtAmountMessage = () => {
    if (props.isPrivate) {
      let messageText = null;
      if (props.amount <= 0) {
        messageText = `היתרה בחשבונך היא ${rtlShekelAmount(props.amount)} ש"ח, אין חיוב לשלם ב${window.Config.brand_Name_HE}`;
      } else if (props.amount > props.maxAmountPrivate) {
        messageText = `חוב מעל ל-${rtlShekelAmount(props.maxAmountPrivate)} ש"ח לא ניתן להשלים בפעולה דיגיטלית`;
      }
      if (messageText) {
        return (
          <Row>
            <Col>
              <BasicText text={messageText} />
            </Col>
          </Row>
        );
      } else return null;
    }
  };

  const canContinue =
    (props.isPrivate && parseFloat(props.amount) > 0 && parseFloat(props.amount) <= props.maxAmountPrivate) || !props.isPrivate;
  const paymentTip =
    !props.selected && props.isPrivate && parseFloat(props.amount) > 0 ? (
      <>
        <span
          className={`paymentAmountTip ${isShowExtra ? 'active' : ''}`}
          onClick={(e) => {
            setShowExtra(!isShowExtra);
            e.stopPropagation();
          }}>
          <BasicText text={'יתרה לתשלום: ' + rtlShekelAmount(props.amount)} classname={'consumerSelectInlinePayment'} bold={true} />
          <ChevronArrow />
        </span>
      </>
    ) : props.isPrivate && props.selected ? (
      <BasicText text={'סה"כ לתשלום: ' + rtlShekelAmount(props.privateAmount)} bold={true} />
    ) : (
      <BasicText text={'יתרה לתשלום: ' + rtlShekelAmount(props.amount)} bold={true} />
    );
  const extraPaymentData = isShowExtra && (
    <>
      <Row>
        <Col className='extraPaymentDataCol'>
          <BasicText text={'יתרת חוב: ' + rtlShekelAmount(props.monthlyBalance)} />
          <BasicText text={'יתרת חוב חשבונית חדשה: ' + rtlShekelAmount(props.invoiceBalance)} />
        </Col>
      </Row>
    </>
  );

  return (
    <div className={`justify-content-md-center debtpayment-step-payment-row `}>
      <div
        className={`debtpayment-payment-box ${props.selected ? 'payment-box-creditcard' : ''} ${
          props.payPendingStatus || (props.isJetConnection && props.activeJetBan == props.number) ? 'jet-active-ban' : ''
        }`}
        onClick={
          !props.selected && canContinue
            ? () => {
                props.onclick();
              }
            : null
        }>
        <div className='debtpayment-payment-row'>
          <div className={`${isMobile ? 'pl-0' : ''} debtpayment-account-name`}>
            <div className={`${isMobile ? 'pl-0' : ''}`}>{paymentTip}</div>

            {extraPaymentData}

            <BasicText text={displayNumber + ' ' + props.name} />

            <BasicText text={props.productDescriptions} />

            {renderPrivateDebtAmountMessage()}
          </div>
          {canContinue ? (
            <div className='debtpayment-paybutton'>
              {props.selected ? (
                <div onClick={() => props.onclick(props.popUpProps)} style={{float: 'left'}}>
                  <BasicImage src={info} classname='i-img' />
                </div>
              ) : (
                <div>
                  <BasicText
                    text={props.payPendingStatus ? 'לסיום וקבלת אישור תשלום' : 'לתשלום'}
                    bold={true}
                    color={props.isPrivate ? 'privatePink' : 'businessPurple'}
                  />
                  <BasicImage src={arrow} classname='arrow-img' />
                </div>
              )}
            </div>
          ) : null}
        </div>
        {props.amount > props.maxAmountPrivate && props.isPrivate ? (
          <div className='debtpayment-payment-row'>
            <Action
              text={'חיוג ' + numWithStarRTL(window.Config.financeCallNumber1) + ' לנציג פיננסי'}
              img={dial}
              onclick={actionOnClick}
              fnParams={window.Config.financeCallNumber1}
              bold
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ConsumerSelect;
